import React from 'react';

import Button from '../Button';
import './styles.scoped.css';

// CP-853: shown in place of the PDF viewer when a document cannot be downloaded.
// The retry re-signs and re-fetches; the hint covers the case where the browser needs
// fresh credentials, which only a page reload can produce.
const DocumentErrorNotice = ({
  message = 'The document could not be loaded.',
  hint = 'If it still does not load, refresh this page in your browser.',
  actionText = 'Reload Document',
  onRetry,
  className = '',
  style = {},
  ...rest
}) => (
  <div className={['document-error', className].filter(Boolean).join(' ')} style={style} {...rest}>
    <div className="message-row">
      <span className="message">{message}</span>
      {onRetry && <Button variant="primary" size="sm" text={actionText} onPress={onRetry} />}
    </div>
    {hint && <span className="hint">{hint}</span>}
  </div>
);

export default DocumentErrorNotice;
